import { DraftMediaPreview } from "@pages/Brief/v2/Draft/DraftMediaPreview";
import { IDrafting, IDraftingMediaAssets } from "@shared/lib/types/drafting";
import { RefObject, useEffect, useState } from "react";
import styles from "./styles.module.scss";

export function assetsFromDraft(draft?: IDrafting) {
  const contents = draft?.draftingContents ?? [];
  const latest =
    contents.find((item) => item._id === draft?.latestDraftingVersionId) ??
    contents[contents.length - 1];
  return latest?.mediaAssets ?? [];
}

export function draftWasChecked(
  assets: IDraftingMediaAssets[],
  hasRun: boolean
) {
  if (hasRun) return true;
  return assets.some(
    (asset) => asset.complianceCheckGeneratedAt || asset.complianceCheckReport
  );
}

export function DraftAssetPreview({
  assets,
  selectedId,
  draftingId,
  draftingVersionId,
  collapsed = false,
  currentTime: currentTimeProp,
  onTimeChange,
  frameRef,
}: {
  assets: IDraftingMediaAssets[];
  selectedId: string;
  draftingId: string;
  draftingVersionId: string;
  collapsed?: boolean;
  currentTime?: number;
  onTimeChange?: (time: number) => void;
  frameRef?: RefObject<HTMLDivElement | null>;
}) {
  const [localTime, setLocalTime] = useState(0);
  const currentTime = currentTimeProp ?? localTime;
  const setCurrentTime = onTimeChange ?? setLocalTime;
  const selected =
    assets.find((asset) => asset._id === selectedId) ?? assets[0];

  useEffect(() => {
    if (currentTimeProp === undefined) setLocalTime(0);
  }, [currentTimeProp, selected?._id]);

  if (!selected) {
    return <p className={styles.statusLine}>No media on this draft.</p>;
  }

  return (
    <div className={styles.assetList}>
      {collapsed ? null : (
        <div ref={frameRef} className={styles.playerFrame}>
          <DraftMediaPreview
            asset={selected}
            draftingId={draftingId}
            draftingVersionId={draftingVersionId}
            mediaAssetId={selected._id}
            currentTime={currentTime}
            onTimeChange={setCurrentTime}
            onAddCommentAt={() => undefined}
            isDrawingEnabled={false}
            draftDrawings={[]}
            onUpdateDraftDrawings={() => undefined}
            activeDrawing={null}
            comments={[]}
          />
        </div>
      )}
    </div>
  );
}
